<template>
  <!--个人中心--编辑教育-->
  <div class="ziliao">
      <div class="titleWrap">
        <p class="titleName">活动申报</p>
        <p class="editorDeal" ><span >申报记录</span></p>
      </div>
      <div class="formWrapper">
        <Form :label-width="80" label-position="right" class="formMin" >
            <FormItem label="活动时间 " >
              <DatePicker class="dateRight" value="2018-09-06"  type="date" placeholder="请选择活动时间" style="width: 250px"></DatePicker>
            </FormItem>
          <FormItem label="活动地点 ">
            <Input  value="" placeholder="请输入活动地点"/>
          </FormItem>
          <FormItem label="主题 ">
            <Input  value="" placeholder="请输入主题"/>
          </FormItem>
          <FormItem label="主办方  ">
            <Input  value="" placeholder="请输入主办方"/>
          </FormItem>
          <FormItem label="活动介绍 ">
            <Input type="textarea" :rows="5" placeholder="请输入活动介绍(100字以内)"/>
          </FormItem>
          <FormItem label="参与照片 " >
            <span class="upload">
                <Upload action="//jsonplaceholder.typicode.com/posts/">
                  <Icon type="ios-add" size="110" color="#dbdbdb"/>
                </Upload>
            </span>
          </FormItem>
        </Form>
        <div class="keepThis"><router-link  to="/ziliao/shenbaosuccess" class="keepBtn">提交申请</router-link></div>
      </div>

  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .upload {
    display: inline-block;
    cursor: pointer;
    background-color: #f9f9f9;
    border:1px dashed #e1e1e1;
    width: 200px;
    height: 144px;
    text-align: center;
    line-height: 144px;
    
  }
.formWrapper{
  width: 330px;
}
  .keepBtn {
    display: inline-block;
    width: 140px;
    height: 52px;
    background-color: #957960;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 18px;
     border-radius: 5px;
  }
  .keepBtn:hover {
    background-color: #957960;
    cursor: pointer;
  }
  .titleWrap {
    height: 40px;
    font-size: 20px;
    padding-bottom: 20px;
    color: #333;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 30px;
    .titleName {
      float: left;
      line-height: 24px;
    }
    .editorDeal {
      float: right;
      color: #957960;
      line-height: 24px;
      cursor: pointer;
      font-size: 16px;
      border:1px solid #957960;
      padding: 5px 10px;
      border-radius: 5px;
      position: relative;
      bottom: 10px;
    }
  }

  .showimg {
    display: inline-block;
    width: 244px;
    height: 200px;
    overflow: hidden;
    vertical-align: bottom;
  }
  .upuser {
    display: inline-block;
    font-size: 18px;
    color: #333;
    cursor: pointer;
  }
  .keepThis {
    padding: 10px 0 0 80px;
  }
  .layoutSide {
    position: relative;
  }
</style>
<script type="text/ecmascript-6">
    export default {
        name: '',
        props: {},
        data() {
            return {
              formValidate:{
                radio:'yes'
              }
            };
        },
        methods: {},
        created() {

        },
        components: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/shenbao.vue